// 그룹 필터 pill — 전체 / 진행 중 / 결정 대기 / 종료 + 카운트 (시안 A2 `.chips`).
// 결정 대기(actionNeeded)만 앰버 톤 — 돈이 걸린 행동이 필요한 그룹이라 목록에서 눈에 띄어야 한다.
// props: { items: [{ id, label, count, tone }], value, onChange }
import React from 'react';
import { T, R } from '../../../theme';
import LtrText from '../../parts/LtrText';

var wrap = { display: 'flex', gap: 7, flexWrap: 'wrap' };
var chip = {
  display: 'inline-flex', alignItems: 'center', gap: 6, height: 29, padding: '0 12px', borderRadius: R.pill,
  border: '1px solid ' + T.bd, background: T.card, fontSize: 12, color: T.body, cursor: 'pointer',
  fontFamily: 'inherit', whiteSpace: 'nowrap', fontWeight: 600
};
var countStyle = { fontWeight: 800 };

// 선택 상태의 색 — 기본은 파랑(선택), 결정 대기는 앰버. border 는 단축만 교체한다(v2 theme.js 규칙).
function chipStyle(on, tone) {
  if (!on) return chip;
  if (tone === 'amber') {
    return Object.assign({}, chip, { border: '1px solid ' + T.warnBd, background: T.warnTint, color: T.warn, fontWeight: 700 });
  }
  return Object.assign({}, chip, { border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress, fontWeight: 700 });
}

function GroupChips(props) {
  var items = props.items || [];
  var onChange = props.onChange;
  return (<div className="ss-chips" style={wrap}>
    {items.map(function (it) {
      var on = it.id === props.value;
      return (<button key={it.id} type="button" data-group={it.id} aria-pressed={on}
        style={chipStyle(on, it.tone)}
        onClick={function () { if (onChange) onChange(it.id); }}>
        <span>{it.label}</span>
        <LtrText style={countStyle}>{it.count}</LtrText>
      </button>);
    })}
  </div>);
}

export default GroupChips;
